/* eslint-disable no-restricted-globals */
import React, { Component } from "react";
import { connect } from 'react-redux';
import { fromJS } from "immutable";
import { bindActionCreators } from 'redux'
import { toast } from "react-toastify";

import TextInputField from '../../infra/components/formInput/CustomTextInput'
import ComboboxInput from '../../infra/components/formInput/ComboboxInput'
import DatePickerInput from '../../infra/components/formInput/DatePickerInput'
import ActionUploadFile from '../../store/action/WAProfile/UploadFile'
import ActionAddPersonalMedia from '../../store/action/WAProfile/UploadPersonalMedia'
import ActionFetchAllClient from '../../store/action/Client/FetchAll'
import ActionFetchAllDivision from '../../store/action/Division/FetchAll'
import ActionFetchSender from '../../store/action/Sender/FetchAll'
import './Form.css'
import chargeSample from '../../upload_template/presonal_media/personal_media.xlsx';
import chargeSampleCatalog from '../../upload_template/presonal_media/personal_media_catalog.xlsx';
import chargeSampleCoupon from '../../upload_template/presonal_media/personal_media_coupon.xlsx';
import chargeSampleLto from '../../upload_template/presonal_media/personal_media_lto.xlsx';
import chargeSampleCarousel from '../../upload_template/presonal_media/personal_media_carousel.xlsx';
import chargeSampleMpm from '../../upload_template/presonal_media/personal_media_mpm.xlsx';
import ActionGetAccessModuleIdAction from '../../store/action/AccessModule/FetchActionDispatch'
import {ClientId, DivisionId, SenderId, SenderName} from "../../helper/HelperAuth";



class Form extends Component {

  constructor(props) {
    super(props);
    this.state = {
      form: fromJS({
        "selected-file": null,
        "upload-completed": false,
        // "loaded": 0,
        "client-id": null,
        "division-id": null,
        "sender-id": '',
        "schedule-date": '',
        "schedule-time": '',
        "file-id": '',
        "file-name": '',
        "sender-word":"",
        "msisdn-uat":"",
        "data-file":null,
        "max-msisdn-uat":5
      }),
      loadded: false,
      disabled: false,
      errors: fromJS({}),
      error: '',
      actionId :'',
      disabledHead: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleOnFileChanged = this.handleOnFileChanged.bind(this);
    this.handleUploadFile = this.handleUploadFile.bind(this);

    this.handleCancelFile = this.handleCancelFile.bind(this);
  }

  componentDidMount() {
    this.props.actionGetAccessModuleIdAction('Personal Media');
    this.props.actionFetchAllClient()
    // this.props.actionFetchAllDivision()
    // this.props.actionFetchSender();
  }

  handleCancelFile(){
    var changeVals = this.state.form;
    var statDis = true;
    var actionIdVar = this.state.actionId;
    if(actionIdVar !=5 ) {
      changeVals = changeVals.set('client-id', null).set('sender-id', null).set('division-id', null).set('sender-word', null)
      statDis = false;
    }
    changeVals = changeVals.set('file-id','');
    changeVals = changeVals.set('file-name','');
    changeVals = changeVals.set('selected-file',null);
    changeVals = changeVals.set('upload-completed', false);
    changeVals = changeVals.set('max-msisdn-uat', 5);
    this.setState({form: changeVals, disabled:false, disabledHead:statDis})
  }

  handleChange(field, value, label) {
    var formVal = this.state.form;
    formVal = formVal.set(field, value);
    if (field === "client-id") {
      this.props.actionFetchSender(value);
      this.props.actionFetchAllDivision(value);

      if(value === '' || value === undefined || value===null){
        formVal = formVal.set(field,value).set('sender-id',null).set('division-id',null)
      }else{
        formVal = formVal.set(field,value)
      }
    }

    if(field === "sender-id"){
      if(value === '' || value === undefined || value===null){
        formVal = formVal.set(field,value).set('sender-word',null)
      }else{
        formVal = formVal.set(field,value).set('sender-word',label)
      }
    }
    this.setState({ form: formVal })
  }

  async handleSubmit(dispatch) {
    const form = this.state.form;
    var isValid = true;
    var msisdnUat = []

    //validasi jumlah uat msisdn number
    var totalMsisdn = form.get('max-msisdn-uat');
    var validTotalMsisdn = true;

    if(form.get('msisdn-uat') != null ){
      // msisdnUat = form.get('msisdn-uat').split(',');
      msisdnUat = form.get('msisdn-uat').replace(/\s/g, "").split(',');
      var inputTotalMsisdn = msisdnUat.length;
      if(inputTotalMsisdn>totalMsisdn){
        validTotalMsisdn=false;
      }
    }
    //debugger;
    form.map((v, k) => {
      if(k !== 'msisdn-uat') {
        if (v === '') {
          isValid = false
        }
      }
    })

    var data =
    {
      'uploads': [{
        "client-id": form.get('client-id'),
        "division-id": form.get('division-id'),
        "sender-id": form.get('sender-id'),
        "schedule-date": form.get('schedule-date'),
        "schedule-time": form.get('schedule-time'),
        "file-id": form.get('file-id'),
        "file-name": form.get('file-name'),
        "data-file":form.get('data-file'),
        "number-add": msisdnUat
      }]
    };
    if (isValid) {
      if(validTotalMsisdn) {
        var response = await this.props.actionAddPersonalMedia(data);
        if (response.ok) {
          // toast.success('Save Success!', toast.POSITION.TOP_RIGHT);
          // window.location = 'ListUpload'
          var res = fromJS(await response.json());
          if (res.get('errors') !== undefined) {
            res = res.get('errors').get(0)
            toast.success(res.get('details'), toast.POSITION.TOP_RIGHT);
          } else {
            toast.success('Save Success!', toast.POSITION.TOP_RIGHT);
          }
          // window.location = 'ListUpload'
          setTimeout(function () {
            window.location = "ListUpload";
          }, 2000); //will call the function after 2 secs.

        } else {

        }
      }else{
        toast.error('Over limit uat number. Maximum uat number is '+totalMsisdn, toast.POSITION.TOP_RIGHT);
      }

    } else {
      toast.error('All field must be filled', toast.POSITION.TOP_RIGHT);
    }
  }

  async handleUploadFile() {
    var file = this.state.form.get('selected-file')
    var varClientId = this.state.form.get('client-id');
    var varDivisionId = this.state.form.get('division-id');
    var varSenderWord = this.state.form.get('sender-word');

    if(varClientId && varDivisionId && varSenderWord) {
            var response = await this.props.actionUploadFile(file, 'PERSONAL MEDIA', varSenderWord, varClientId, varDivisionId,"5");
      if (response.get('success')) {
        let newForm = this.state.form;

        newForm = newForm.set('file-id', response.get('file-id'));
        newForm = newForm.set('file-name', response.get('file-name'));
        newForm = newForm.set('upload-completed', true);
        newForm = newForm.set('data-file', response.get('data-file'));
        if(response.get('max-msisdn-uat')){
          newForm = newForm.set('max-msisdn-uat', response.get('max-msisdn-uat'));
        }
        this.setState({
          form: newForm,
          disabled: true,
          disabledHead: true
        })
      } else {
        toast.error('Upload Failed', toast.POSITION.TOP_RIGHT);
      }
    }else{
      toast.error('Client, Division, Sender and file must be filled',toast.POSITION.TOP_RIGHT);
    }
  }

  handleCancel() {
    window.location = 'ListUpload'
  }

  handleOnFileChanged() {
    let newForm = this.state.form;
    newForm = newForm.set("selected-file", event.target.files[0]);
    this.setState({
      form: newForm
    })
  }

  async changeActionId(){
    var valueActionId = this.state.actionId;
    if(valueActionId ===null || valueActionId===undefined || valueActionId===''){
      var varActionId = "";
      var dataAkses =null;
      setTimeout(() => {
        dataAkses = this.props.accessmoduleaction;
        if(dataAkses){
          varActionId=dataAkses.get("action-id");
        }
        if(varActionId==5){
          this.props.actionFetchSender(ClientId);
          this.props.actionFetchAllDivision(ClientId);
          var formVal = this.state.form;
          formVal = formVal.set('client-id',ClientId).set('sender-id',SenderId).set('division-id',DivisionId).set('sender-word',SenderName);
          this.setState({
            form: formVal,
            disabledHead: true,
            actionId :varActionId,
          })
        }else{
          this.setState({
            actionId :varActionId,
          })
        }
      }, 500);
    }
  }

  render() {
    const { form, errors, disabled } = this.state;
    let varActionId = this.state.actionId;
    if(varActionId==='' || varActionId===undefined){
      this.changeActionId();
    }

    return (
      <div className="clearfix">
        <div className="card-noborder">
          <h4>
            Personal Media
          </h4>
        </div>
        <div className="card">
          <div className="body clearfix">
            <div className="form-group">
              <span className="col-sm-2">Example File Upload</span>
              <div className="col-sm-10">
                <div class="btn-group" role="group">
                  <a target="_blank" href={chargeSample} download="personal_media" class="btn btn-success">General</a>
                  {/* <a target="_blank" href={chargeSampleCatalog} download="personal_media_catalog" class="btn btn-warning">Catalog</a> */}
                  <a target="_blank" href={chargeSampleCoupon} download="personal_media_coupon" class="btn btn-primary">Coupon</a>
                  <a target="_blank" href={chargeSampleLto} download="personal_media_lto" class="btn btn-success">LTO</a>
                  {/* <a target="_blank" href={chargeSampleCarousel} download="personal_media_carousel" class="btn btn-warning">Carousel</a> */}
                  {/* <a target="_blank" href={chargeSampleMpm} download="personal_media_mpm" class="btn btn-primary">MPM</a> */}
                </div>
              </div>
            </div>

            <div className="form-group">
              <span className="col-sm-2">Client</span>
              <div className="col-sm-10">
                <ComboboxInput
                    field='client-id'
                    value={form.get('client-id')}
                    options={fromJS({
                      'source': this.props.Clientall,
                      'value': 'client-id',
                      'label': 'client-name'
                    })}
                    onChange={(field, value, label) => this.handleChange(field, value, label)}
                    placeholder="Client"
                    disabled={this.state.disabledHead}
                    hasError={errors.has('client-id')}
                />
              </div>
            </div>

            <div className="form-group">
              <span className="col-sm-2">Division</span>
              <div className="col-sm-10">
                <ComboboxInput
                    field='division-id'
                    value={form.get('division-id')}
                    options={fromJS({
                      'source': this.props.Divisionall,
                      'value': 'division-id',
                      'label': 'division-name'
                    })}
                    onChange={(field, value, label) => this.handleChange(field, value, label)}
                    placeholder="Division"
                    disabled={this.state.disabledHead}
                    hasError={errors.has('division-id')}
                />
              </div>
            </div>

            <div className="form-group">
              <span className="col-sm-2">Sender</span>
              <div className="col-sm-10">
                <ComboboxInput
                    field='sender-id'
                    value={form.get('sender-id')}
                    options={fromJS({
                      'source': this.props.Senders,
                      'value': 'sender-id',
                      'label': 'sender-name'
                    })}
                    onChange={(field, value, label) => this.handleChange(field, value, label)}
                    placeholder="Sender"
                    disabled={this.state.disabledHead}
                    hasError={errors.has('sender-id')}
                />
              </div>
            </div>

            <div className="form-group">
              <span className="col-sm-2">File Upload</span>
              <div className="col-sm-10">
                <input className="form-control" type="file" name="file" disabled={this.state.disabled} onChange={this.handleOnFileChanged} />
              </div>
            </div>

            <div className="form-group">
              <span className="col-sm-2"></span>
              <div className="col-sm-10">
                <button type="button"
                  className="btn btn-info"
                  disabled={this.state.disabled}
                  onClick={this.handleUploadFile}>
                  Upload
                </button>
                <button type="button"
                        className="btn btn-danger"
                        disabled={!this.state.disabled}
                        onClick={this.handleCancelFile}>
                  Change
                </button>
                <label className="lbl-info">
                  {"filename : " + form.get('file-name')}
                </label>
                <label className="lbl-info">
                  {"file-id : " + form.get('file-id')}
                </label>
              </div>
            </div>
            <div className="form-group">
              <span className="col-sm-2">Send Date</span>
              <div className="col-sm-10">
                <DatePickerInput
                  convertvalue
                  minDate={new Date()-1}
                  field="schedule-date"
                  dateFormat="yyyy-MM-dd"
                  value={form.get('schedule-date')}
                  onChange={(field, date) => this.handleChange(field, date)}
                />
              </div>
            </div>

            <div className="form-group">
              <span className="col-sm-2">Send Time</span>
              <div className="col-sm-10">
                <DatePickerInput
                  className="business-hour-time"
                  type="Time"
                  convertvalue
                  field="schedule-time"
                  value={form.get('schedule-time')}
                  dateFormat="HH:mm:ss"
                  onChange={(field, date) => this.handleChange(field, date)}
                />
              </div>
            </div>
            <div className="form-group">
              <span className="col-sm-2">UAT Msisdn</span>
              <div className="col-sm-10">
                <TextInputField className="form-control"
                                textarea
                    // disabled="false"
                                field={'msisdn-uat'}
                                value={form.get('msisdn-uat')}
                                onChange={(field, value) => this.handleChange(field, value)}
                                placeholder="Msisdn for UAT. ex: 6281234567, 6281234568"
                    // hasError={errors.has('msisdn-uat')}
                />
              </div>
            </div>

            <div className="form-group">
              <span className="col-sm-2"></span>
              <div className="col-sm-6">
                <button type="button"
                  className="btn btn-width btn-danger"
                  value="Cancel"
                  onClick={this.handleCancel}>
                  Cancel
              </button>
                <button type="button"
                  disabled={!form.get("upload-completed")}
                  className="btn btn-width btn-success"
                  onClick={this.handleSubmit}>
                  Submit
              </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


export default connect(
  (state) => {
    return {
      Users: state.user.users,
      Clientall: state.user.clientall,
      Divisionall: state.user.divisionall,
      Senders: state.user.senders,
      accessmoduleaction: state.user.accessmoduleaction,
    }
  },
  dispatch => bindActionCreators({
    actionUploadFile: ActionUploadFile,
    actionAddPersonalMedia: ActionAddPersonalMedia,
    actionFetchAllClient: ActionFetchAllClient,
    actionFetchAllDivision: ActionFetchAllDivision,
    actionFetchSender: ActionFetchSender,
    actionGetAccessModuleIdAction:ActionGetAccessModuleIdAction,
  }, dispatch),
)(Form);